var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 619.55 382.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#59c9e9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.53,149.38S91.36,148.43,29.06,381.53c0,0-60.29-280.89,252.71-301.89,0,0,410.58-222.92,300.29,303C582.06,382.68,507.3,203.12,304.53,149.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.77 302.64 82.67 358.75 84.77 213.88 45.77 302.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "521 272.23 510.65 379.77 560.76 325.64 560.93 272.23 521 272.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.03 264.63 108.77 279.64 128.09 217.82 171.87 234.56 182.91 181.6 257.67 248.64 272.68 152.48 290.52 207.7 304.53 149.38 325.76 239.64 366.16 170.97 371.76 246.64 417.36 198.01 431.76 241.64 445.69 217.25 450.39 285.23 479.57 245.1 468.63 302.7 519.62 286.53 556.76 218.64 382.54 82.22 252.38 112.02 133.76 161.64 84.03 264.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.87,138.89s1.9-242.7,247.12-86.45L261,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,241.67S4.36,79.53,154.56,114.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.06,381.53s-68.63-120.63,5-180.26l18.5,12.61L34,285.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.84,258.38s54.51,63.34-17.78,124.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset17);
export default __webpack_public_path__ + "static/media/Asset 17.00b7162f.svg";
export { ForwardRef as ReactComponent };